import { Field, Flex, Input } from "@chakra-ui/react";
import { Header } from "components/Header";
import TableList from "components/TableList";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const headers = ["item"];

const items = [
  {
    id: 1,
    item: "item 1",
  },
];

function CustomPricingRules() {
  const [isLoading] = useState(false);
  // const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  // const [activePage, setActivePage] = useState(1);
  // const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const navigate = useNavigate();

  const onSelect = () => {
    navigate("/custompricingrulesview");
  };

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Custom Pricing Rules"} isLoading={isLoading} />
      <Flex justifyContent="space-between" gap={"3"}>
        {/* <DropDown/> */}
        <Field.Root orientation="horizontal" w={"22rem"}>
          <Field.Label textStyle={"md"}>Search</Field.Label>
          <Input textStyle={"md"} />
        </Field.Root>

        {/* <Button variant="outline" onClick={onNew}>New</Button> */}
      </Flex>
      <TableList onSelect={onSelect} headers={headers} items={items} />
    </Flex>
  );
}

export default CustomPricingRules;
